/* eslint-disable max-len */
import apiClient from '../api';
import { executeAndWaitResponse } from './service';

export const getTable = async (table) => executeAndWaitResponse(() => apiClient.bi.getTable(table));

export default {
  getTable,
};
